import {
  useDisclosure,
  Menu,
  MenuButton,
  IconButton,
  Portal,
  MenuList,
  MenuItem,
  MenuDivider,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '../../Icons';
import { AddSamplesToBrandTransportRequestModal } from '../../transportRequests/AddSamplesToBrandTransportRequestModal';
import { AddSamplesToTransportInternalRequestModal } from '../../transportRequests/AddSamplesToTransportInternalRequestModal';
import { transportRequestEvents } from '../../transportRequests/events';
import {
  SampleNextActionProps,
  GeneralSamplesMenuActions,
  useGeneralSampleModals,
} from '../SampleNextAction';
import { usePortalRefValue } from '@texas/hooks/usePortalRef';

export function SendToBrandOrHandlePa(props: SampleNextActionProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onClose: onClose2,
    onOpen: onOpen2,
  } = useDisclosure();
  const { t } = useTranslation();
  const { ref } = usePortalRefValue();

  const {
    setLostOnOpen,
    updateOwnerOnOpen,
    rejectOnOpen,
    stopFollowOnOpen,
    modals,
  } = useGeneralSampleModals();

  if (!props.sampleId) {
    return null;
  }

  return (
    <>
      <Menu isLazy={true}>
        <MenuButton
          as={IconButton}
          size="sm"
          variant="ghost"
          aria-label={t('sample.send')}
          icon={<Icons.DotsHorizontal boxSize={defaultIconSize} />}
        />
        <Portal containerRef={ref}>
          <MenuList zIndex={10}>
            <MenuItem
              onClick={onOpen2}
              icon={<Icons.TruckFast boxSize={defaultIconSize} />}
            >
              {t('sample.sendCustomer')}
            </MenuItem>
            <MenuItem
              onClick={onOpen}
              icon={<Icons.TruckDelivery boxSize={defaultIconSize} />}
            >
              {t('sample.sendInternal')}
            </MenuItem>
            <MenuDivider />
            <GeneralSamplesMenuActions
              pas={[props.pa!]}
              sampleIds={[props.sampleId]}
              rejectOnOpen={rejectOnOpen}
              setLostOnOpen={setLostOnOpen}
              updateOwnerOnOpen={updateOwnerOnOpen}
              stopFollowOnOpen={
                props.hideStopFollowing ? null : stopFollowOnOpen
              }
            />
          </MenuList>
        </Portal>
      </Menu>

      {modals}
      <AddSamplesToTransportInternalRequestModal
        isOpen={isOpen}
        onClose={onClose}
        sampleIds={[props.sampleId]}
        onAdded={() => transportRequestEvents.onSamplesAdded.dispatch()}
      />
      <AddSamplesToBrandTransportRequestModal
        isOpen={isOpen2}
        onClose={onClose2}
        sampleIds={[props.sampleId]}
        onAdded={() => transportRequestEvents.onSamplesAdded.dispatch()}
      />
    </>
  );
}
